// extracted by mini-css-extract-plugin
export default {"tfoot":"tfoot_tfoot__5ir8b"};